/**
 * @param   {EditorState} editorState
 * @returns {Boolean}
 */
export default function shouldDisplayPlaceholder(editorState) {
  const contentState = editorState.getCurrentContent();

  return (
    contentState.hasText() === false &&
    contentState
      .getBlockMap()
      .first()
      .getType() === "unstyled"
  );
}
